//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const FixateOnlyInPostSubmit: FeatureFlag = {"Id":"FixateOnlyInPostSubmit","Label":"(Performance) Fixate only in post-submit","Impact":"Normally, submit-time Edit fixation can happen before post-submit completes. When this is enabled, Edit fixation is deferred until the post-submit step.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
